import HolidayIcon from '@material-ui/icons/Event'; // Change the icon to something related to holidays
import HolidayList from './HolidayList';
import CreateHoliday from './CreateHoliday';
import customDataProvider   from "../dataProvider/CustomDataProvider";
import EditHoliday from "./EditHoliday";
export default {
    list: HolidayList,
    edit: EditHoliday,
    create: CreateHoliday,
    icon: HolidayIcon,
    dataProvider: customDataProvider
};
